/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IMyScriptInjectorData } from './my-script-injector.data';
import { IMyScriptInjectorProps } from './my-script-injector.props.autogenerated';

export interface IMyScriptInjectorViewProps extends IMyScriptInjectorProps<IMyScriptInjectorData> {}

/**
 *
 * MyScriptInjector component
 * @extends {React.PureComponent<IMyScriptInjectorProps<IMyScriptInjectorData>>}
 */
class MyScriptInjector extends React.PureComponent<IMyScriptInjectorProps<IMyScriptInjectorData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default MyScriptInjector;
